<template>
  <v-snackbar v-model="notify.isShow" top :color="color" :timeout="3000">
    <v-icon>{{ `mdi-${icon}` }}</v-icon>
    <template v-for="(item, index) in notify.msg">
      <span :key="item + index">{{ item }}</span>
    </template>
    <template v-slot:action="{ attrs }">
      <v-btn icon v-bind="attrs" @click="notify.isShow = false">
        <v-icon small>mdi-close</v-icon>
        <span style="font-size: 0rem">{{ $t('close') }}</span>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Notify',
  data: () => ({}),
  computed: {
    ...mapState('notify', ['notify']),
    icon() {
      switch (this.notify.type) {
        default:
        case 'info':
          return 'information';
        case 'success':
          return 'check-circle';
        case 'warning':
          return 'alert-outline';
        case 'alarm':
          return 'alert';
      }
    },
    color() {
      switch (this.notify.type) {
        default:
        case 'info':
          return 'light-blue darken-1';
        case 'success':
          return 'green darken-1';
        case 'warning':
          return 'orange darken-1';
        case 'alarm':
          return 'red darken-1';
      }
    },
  },
};
</script>
